import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";

// Freeform input with async suggestions (service people, per-property units).
export function SuggestInput({ value, onChange, fetchItems, deps = [], placeholder, testId }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [hi, setHi] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      fetchItems(value || "").then((list) => { setItems(list || []); setHi(0); }).catch(() => setItems([]));
    }, 180);
    return () => clearTimeout(timer.current);
  }, [value, open, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps

  const shown = items.filter((s) => s !== value).slice(0, 8);
  const pick = (s) => { onChange(s); setOpen(false); };

  return (
    <div className="relative">
      <Input
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={(e) => {
          if (!open || !shown.length) return;
          if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(h + 1, shown.length - 1)); }
          if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
          if (e.key === "Enter") { e.preventDefault(); pick(shown[hi]); }
          if (e.key === "Escape") setOpen(false);
        }}
        placeholder={placeholder}
        autoComplete="off"
        data-testid={testId}
      />
      {open && shown.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-48 overflow-y-auto" data-testid={`${testId}-suggestions`}>
          {shown.map((s, i) => (
            <button
              key={s}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              className={`w-full text-left px-3 py-2 text-sm transition-colors ${i === hi ? "bg-[#eaf2ff] text-[#1f64c2]" : "text-slate-700 hover:bg-slate-50"}`}
              data-testid={`${testId}-suggestion-${i}`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
